// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"1cd54a52","114":"ef5d4e35","331":"1278d0a4","411":"f69e8b72","453":"803034b0","515":"d8df4c04","793":"e3b232c0"}[chunkId] + ".chunk.js";
};